import { getUserStore } from "../store/store";
import { mutatorAction } from "satcheljs";
import { PrioritizeRequestStatus } from "../store/PrioritizeRequestStatus";
import type { MailboxInfo } from "owa-client-types";
import type { TableView } from "owa-mail-list-store";
import { getRowsToPrioritize } from "../utils/getRowsToPrioritize";
import { isPriorityNudgeEnabled } from "owa-copilot-settings-utils";

const updatePrioritizeRequestStatusNudgedMutator: (mailboxInfo: MailboxInfo, tableView: TableView) => void = mutatorAction("updatePrioritizeRequestStatus", (mailboxInfo: MailboxInfo, tableView: TableView): void => {
    if (!isPriorityNudgeEnabled(mailboxInfo)) {
        return;
    }
    
    const rowsToPrioritize = tableView
        ? getRowsToPrioritize(tableView, true /* isForNudge */)
        : [];
    const store = getUserStore(mailboxInfo);
    
    if (rowsToPrioritize.length >= 10 &&
        store.prioritizeRequestStatus === PrioritizeRequestStatus.None) {
        store.prioritizeRequestStatus = PrioritizeRequestStatus.Nudged;
    }
});

export default updatePrioritizeRequestStatusNudgedMutator;
